import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { cellRawValue, GridColumn } from '../components/kl-grid/grid.models';
import { formatKlDateValue } from '../utils/kl-date-format';

/** Formatted display value for a `kl-grid-container` body cell; pure, so unchanged row/col skip re-formatting. */
@Pipe({
  name: 'klGridCellValue',
  standalone: false,
})
export class KlGridCellValuePipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(row: any, col: GridColumn): string {
    return formatGridCellValue(row, col, this.translate);
  }
}

/** Cell text as the grid shows it; shared by the pipe and row copy. */
export function formatGridCellValue(row: object, col: GridColumn, translate: TranslateService): string {
  const binding = col.binding;
  if (!binding) return '';
  const raw = cellRawValue(row, binding);
  if (raw == null || raw === '') return '';

  if (col.format === 'date') return formatKlDateValue(raw, false);
  if (col.format === 'date-time') return formatKlDateValue(raw, true);
  if (col.displayFractionDigits != null) {
    // Some backend fields (e.g. BigDecimal amounts) arrive as numeric strings, not JS numbers.
    const numeric = typeof raw === 'number' ? raw : typeof raw === 'string' ? Number(raw) : NaN;
    if (Number.isFinite(numeric)) {
      const fd = col.displayFractionDigits;
      return new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: fd,
        maximumFractionDigits: fd,
        useGrouping: !!col.numberGrouping,
      }).format(numeric);
    }
  }
  if (col.translate) return translate.instant(String(raw));
  if (typeof raw === 'object') {
    return '';
  }
  return String(raw);
}
